import { Injectable } from "@angular/core";
import { BrowserWindowService } from "apps-module/app/shared-library/services/environment/browser-window.service";
import { QueryStringSerializationService } from "apps-module/app/shared-library/services/environment/query-string-serialization.service";
import { nameof } from "apps-module/app/shared-library/utils/common.utils";
import { NumericUtils } from "apps-module/app/shared-library/utils/numeric.utils";

import { DatesFilterOptions } from "../components/search-filters/dates-filter/dates-filter-options.enum";
import { SearchConfigurationModel } from "../models/search-configuration.model";
import { SearchFilterModel } from "../models/search-filter.model";

@Injectable()
export class SearchParametersService {

    public constructor(
        private readonly _browserWindowService: BrowserWindowService,
        private readonly _serializationService: QueryStringSerializationService
    ) {
    }

    public create(queryString: string, configuration: SearchConfigurationModel): SearchFilterModel {
        const rawValues = this._serializationService.deserialize(queryString);

        const formParameters = {
            searchContext: configuration.searchContext,
            searchText: rawValues[nameof<SearchFilterModel>("searchText")] as string || "",
            pageNumber: NumericUtils.parse(rawValues[nameof<SearchFilterModel>("pageNumber")] as string, 1),
            pageSize: NumericUtils.parse(rawValues[nameof<SearchFilterModel>("pageSize")] as string, 12),
            sortOption: rawValues[nameof<SearchFilterModel>("sortOption")] as string || "0",
            datesRange: NumericUtils.parse(rawValues[nameof<SearchFilterModel>("datesRange")] as string, DatesFilterOptions.All),
            fromDate: rawValues[nameof<SearchFilterModel>("fromDate")] as string || "",
            toDate: rawValues[nameof<SearchFilterModel>("toDate")] as string || "",
            trainingFormat: rawValues[nameof<SearchFilterModel>("trainingFormat")] as Array<string> || [],
            targetAudience: rawValues[nameof<SearchFilterModel>("targetAudience")] as Array<string> || [],
            coursePhase: rawValues[nameof<SearchFilterModel>("coursePhase")] as Array<string> || [],
            courseType: rawValues[nameof<SearchFilterModel>("courseType")] as Array<string> || []
        } as SearchFilterModel;

        if (!formParameters.searchText && (formParameters.sortOption === "0")) {
            formParameters.sortOption = "3";
        }

        return formParameters;
    }

    public set(searchParameters: SearchFilterModel): void {
        const queryParams = {
            searchContext: searchParameters.searchContext,
            searchText: searchParameters.searchText,
            pageNumber: searchParameters.pageNumber,
            pageSize: searchParameters.pageSize,
            sortOption: searchParameters.sortOption,
            datesRange: searchParameters.datesRange,
            fromDate: searchParameters.fromDate,
            toDate: searchParameters.toDate,
            trainingFormat: searchParameters.trainingFormat,
            targetAudience: searchParameters.targetAudience,
            coursePhase: searchParameters.coursePhase,
            courseType: searchParameters.courseType
        } as SearchFilterModel;

        const queryString = this._serializationService.serialize(queryParams);

        this._browserWindowService.setQueryString(queryString);
    }
}
